module.exports = __webpack_public_path__ + "starTrue.75f5363a.png";